import React from 'react';
import { ITables } from '../all-types';

type Props = React.SVGProps<SVGSVGElement> & ITables;

const SquareTableTop: React.FC<Props> = ({
  tableColor = '#000000',
  capacity,
  width = 200,
  height = 200,
  tableNo,
  isActive,
  status,
  ...rest
}) => {
  const textColor = '#fff';

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 200 200"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      {/* Square tabletop */}
      <rect
        x="10"
        y="10"
        width="180"
        height="180"
        fill={tableColor}
        stroke="#444"
        strokeWidth={4}
        rx={8}
        ry={8}
      />

      {/* Table number */}
      <text
        x="100"
        y="100"
        fontSize="40"
        fill={textColor}
        fontWeight="bold"
        textAnchor="middle"
        dominantBaseline="middle"
      >
        T{tableNo}
      </text>

      {/* Capacity */}
      <text
        x="100"
        y="135"
        fontSize="14"
        fill={textColor}
        textAnchor="middle"
      >
        Capacity: {capacity}
      </text>

      {/* Status indicators */}
      {status !== "OCCUPIED" && (
        <circle cx="25" cy="25" r="10" fill="red">
          <title>Occupied</title>
        </circle>
      )}
      {isActive === false && (
        <circle cx="175" cy="25" r="10" fill="gray">
          <title>Not Working</title>
        </circle>
      )}
    </svg>
  );
};

export { SquareTableTop };
